export const getInitialSelectedCountry = (initialCountry, countries) => {
    let initialSelectedCountry = countries?.[0];
    if (initialCountry) {
        const initialCountryObject = countries?.find((country) => country.id === parseInt(initialCountry));
        if (initialCountryObject?.permitted) {
            initialSelectedCountry = initialCountryObject;
        }
    }
    return initialSelectedCountry;
};
